import { useEffect, type ReactNode } from 'react';
import { create } from 'zustand';

interface HeaderActionsSlotState {
  node: ReactNode | null;
  setNode: (node: ReactNode | null) => void;
}

/**
 * Right-hand action slot for the persistent app shell — the counterpart of
 * `useBreadcrumbSlot`. A deep page publishes its top-bar buttons here and
 * `AppTopBar` renders them left of the bell.
 */
export const useHeaderActionsSlot = create<HeaderActionsSlotState>((set) => ({
  node: null,
  setNode: (node) => set({ node }),
}));

/** Publishes `node` into the top bar while mounted; `null` publishes nothing. */
export function usePublishHeaderActions(node: ReactNode | null): void {
  const setNode = useHeaderActionsSlot((s) => s.setNode);
  useEffect(() => {
    setNode(node);
  }, [node, setNode]);
  useEffect(() => () => setNode(null), [setNode]);
}
